import { Address } from "shared/apiClient";

export function sortByDate(
  a: { created_at?: string } | null,
  b: { created_at?: string } | null,
): number {
  const dateA = new Date(a?.created_at || "");
  const dateB = new Date(b?.created_at || "");
  if (dateA < dateB) {
    return -1;
  }
  if (dateA > dateB) {
    return 1;
  }
  return 0;
}

export function lotSizeDescription(address: Address): string {
  const lotSize = address?.lot_size_sqm || 0;
  const lotSizeUnits = lotSize > 10000 ? "ha" : "m²";

  const lotSizeInUnits = Number(
    lotSize > 10000 ? lotSize / 10000 : lotSize,
  ).toLocaleString("en-AU", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return `${lotSizeInUnits}${lotSizeUnits}`;
}
